var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08832 0.941177L8.96783 0.948174C8.68996 0.980593 8.43825 1.12405 8.28074 1.34457L6.62691 3.65882H3.26479C1.65667 3.65882 0.353027 4.87556 0.353027 6.37647V16.3412C0.353027 17.8421 1.65667 19.0588 3.26479 19.0588H20.7354C22.3435 19.0588 23.6471 17.8421 23.6471 16.3412V6.37647L23.6422 6.21679C23.5536 4.7902 22.2861 3.65882 20.7354 3.65882H17.3723L15.7194 1.34457C15.5394 1.09255 15.2364 0.941177 14.9118 0.941177H9.08832ZM9.6075 2.75293H14.3915L16.0454 5.06719C16.2254 5.31921 16.5284 5.47058 16.8529 5.47058H20.7353C21.2713 5.47058 21.7059 5.87616 21.7059 6.37646V16.3412C21.7059 16.8415 21.2713 17.2471 20.7353 17.2471H3.26471C2.72866 17.2471 2.29412 16.8415 2.29412 16.3412V6.37646C2.29412 5.87616 2.72866 5.47058 3.26471 5.47058H7.14706L7.26755 5.46358C7.54542 5.43116 7.79713 5.2877 7.95464 5.06719L9.6075 2.75293ZM12 6.37647C9.31979 6.37647 7.14706 8.40435 7.14706 10.9059C7.14706 13.4074 9.31979 15.4353 12 15.4353C14.6802 15.4353 16.8529 13.4074 16.8529 10.9059C16.8529 8.40435 14.6802 6.37647 12 6.37647ZM12.0001 8.18823C13.6082 8.18823 14.9118 9.40496 14.9118 10.9059C14.9118 12.4068 13.6082 13.6235 12.0001 13.6235C10.392 13.6235 9.08832 12.4068 9.08832 10.9059C9.08832 9.40496 10.392 8.18823 12.0001 8.18823Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.ab5fd5c7c8e6ba98ce3ee17e5775f129.svg";
export { ForwardRef as ReactComponent };